import Vue from 'vue';

Vue.filter('numFormat', function (num) {
  return Number(num).toLocaleString()
})

Vue.filter('currencyFormatter', function (num, currency) {
  if (currency.includes('1000')) currency = currency.split('1000')[0];
  let locale = "";
  if (currency === 'EUR' || currency === 'IDR') {
    locale = "id-ID";
  } else {
    locale = "th-TH";
  }
  let libfrom = new Intl.NumberFormat(`${locale}`, {
    currency: `${currency}`,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return libfrom.format(num);
})

Vue.filter('balanceFormatter', function (num) {
  let x = num;
  let point = getPrecision(num);
  if (point <= 1) point = 2;
  if (x === 0) return "0.00";
  else if (!x) return x;
  return String(x.toFixed(2)).replace(/\d(?=(\d{3})+\.)/g, "$&,")
  // return x.toFixed(2);
})
Vue.filter('commaSeperate', function (num) {
  return String(num).replace(/\d(?=(\d{3})+\.)/g, "$&,")
})

function getPrecision(num) {
  var numAsStr = num.toFixed(10);
  numAsStr = numAsStr.replace(/0+$/g, '');
  var precision = String(numAsStr).replace('.', '').length - num.toFixed().length;
  return precision;
}

export default {
  dateTimeFormatter(unix) {
    let t = new Date(unix)
    const zeroPad = (value, size) => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value)
    return `${zeroPad(t.getFullYear(), 2)}-${zeroPad(t.getMonth() + 1, 2)}-${zeroPad(t.getDate(), 2)} ${zeroPad(t.getHours(), 2)}:${zeroPad(t.getMinutes(), 2)}:${zeroPad(t.getSeconds(), 2)}`
  },
  getCurrencySign(currency) {
    if (currency) {
      if (currency.includes('1000')) {
        return currency.split('1000')[0];
      }
      else return currency;
    }
    else return 'THB';
  },
  normalCurrrency(value, currency) {
    if (currency === 'USD' || currency === 'GBP' || currency === 'AUD') {
      let libfrom = new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: `${currency}`,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currencyDisplay: "narrowSymbol"
      });
      return libfrom.format(value);
    }
    else if (currency === 'MYR' || currency === 'MMK') {
      let libfrom = new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: `${currency}`,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currencyDisplay: "narrowSymbol"
      });
      let str = libfrom.format(value).split(' ');
      return str[0] + str[1];
    }
    else if (currency === 'EUR') {
      let libfrom = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: `${currency}`,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currencyDisplay: "narrowSymbol"
      });
      return libfrom.format(value)
    }
    else {
      let libfrom = new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: `${currency}`,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currencyDisplay: "narrowSymbol"
      });
      return libfrom.format(value);
    }
  }
}
